var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader',{ref:"crcaLoader",attrs:{"fullScreen":""}}),(_vm.reportEmbedReady)?_c('iframe',{style:(_vm.iframeStyle),attrs:{"src":_vm.embedUrl,"height":_vm.iframeHeight}}):_c('p',[_vm._v("No report selected.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }